// API
export const API_ENDPOINT = "https://api.cryptocape.com";
// export const API_ENDPOINT = "http://localhost:8420";